// Omnix/common/schemas/collections/omniChannelConfigs.js
import { z } from "zod";

const OmniChannelConfigSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this configuration belongs to."),

    name: z.string().min(1, "A friendly name for this channel is required.").describe("User-friendly name (e.g., 'Main Support Line', 'Sales WhatsApp')."),

    channelType: z.enum(["voice", "sms", "whatsapp", "email", "web_chat", "facebook_messenger", "instagram", "telegram"])
        .describe("The primary type of channel this configuration represents."),

    provider: z.string().min(1).describe("The name of the provider implementation (e.g., 'twilio', 'whatsapp-web', 'smtp')."),

    // Credentials will be stored directly for now, encrypted in a future phase.
    credentials: z.record(z.any()).optional().describe("Provider-specific credentials (e.g., API keys, tokens)."),

    refreshToken: z.string().optional().nullable().describe("Encrypted OAuth refresh token."),
    accessToken: z.string().optional().nullable().describe("Encrypted OAuth access token."),
    tokenExpiry: z.coerce.date().optional().nullable().describe("Expiry date of the access token."),
    providerUserId: z.string().optional().nullable().describe("The user's unique ID from the OAuth provider (e.g., Google subject ID)."),


    settings: z.record(z.any()).optional().describe("Channel-specific settings and identifiers."),
    // Example for Voice/SMS: { phoneNumber: "+15551234567", capabilities: ["voice", "sms"] }
    // Example for WhatsApp: { clientId: "whatsapp:...", sessionData: { ... } }
    // Example for Web Chat: { widgetId: "...", apiKey: "...", allowedDomains: ["..."] }

    inboundWorkflowId: z.string().optional().nullable().describe("The ID of the workflow to trigger for inbound events. If null, calls UnifiedInboxService directly."),
    inboundSmsWorkflowId: z.string().optional().nullable().describe("The ID of the workflow for inbound SMS events (Twilio)."),
    inboundVoiceWorkflowId: z.string().optional().nullable().describe("The ID of the workflow for inbound voice events (Twilio)."),
    isEnabled: z.boolean().default(true).describe("Master switch to activate or deactivate this channel instance."),

    status: z.string().default("disconnected").describe("The real-time operational status of the instance (e.g., 'connected', 'disconnected', 'auth_failure', 'requires_qr_scan')."),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniChannelConfigSchema;